export class Controller {

    /** @ngInject */
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
    }

    templateUrl() {
        return require(`./sms-settings-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-settings/sms-settings.controller.js